module.exports = __webpack_public_path__ + "static/media/html5.d0f854f7.png";